export default class Utility {
    public static randomString(length: number = 10) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return result;
    }

    public static isNullOrWhitespace(value: any) {
        if (value === null || value === undefined)  { return true; };
        if (value.toString().trim() === '') { return true; };
        return false;
        
    }

    public static proxyImage(imageUrl) {
        if (!imageUrl) {
            return ''
        };
        
        // Nếu ảnh đã là từ domain local thì không cần proxy
        if (imageUrl.startsWith('/') || imageUrl.includes(window.location.hostname) || imageUrl.includes('firebase') || !imageUrl.includes('alicdn.com')) {
            return imageUrl;
        }
        // return 'https://images.weserv.nl/?url=' + encodeURIComponent(imageUrl);
        return `https://image-proxy.mamdtech.com/oee-images/${imageUrl.replace(/https?:\/\//, '')}`;
    }
}